import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
    MANAGE_BIOGRAPHIES: {
        path: `${baseRoutes.adminBaseRoutes}`,
        icon: (
          <span className="nk-menu-icon">
            <em className="icon-file-text-edit" />
          </span>
        ),
      },
    BIOGRAPHIES: {
        path: `${baseRoutes.adminBaseRoutes}/biographies`,
    },
    REPORT_BIOGRAPHIES: {
        path: `${baseRoutes.adminBaseRoutes}/report-biographies`,
    },
};

export default accessRoute;